/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { IGynicHistory } from 'app/shared/model/gynic-history.model';
import { IObstetricEvent } from 'app/shared/model/obstetric-event.model';
import { PhysicalActivity } from 'app/shared/model/enumerations/physical-activity.model';
import { Habbits } from 'app/shared/model/enumerations/habbits.model';
import { NutritionType } from 'app/shared/model/enumerations/nutrition-type.model';
import { AssessmentType } from 'app/shared/model/enumerations/assessment-type.model';
import { TriageCode } from 'app/shared/model/enumerations/triage-code.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { SedationScore } from 'app/shared/model/enumerations/sedation-score.model';

export interface IPreAssessment {
  id?: string;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  physicalActivity?: keyof typeof PhysicalActivity;
  habbits?: keyof typeof Habbits;
  habbitDetails?: string | null;
  sexualAbuse?: boolean;
  sexualAbuseDetails?: string | null;
  exposureToPets?: boolean;
  exposureToPetsDetails?: string | null;
  nutritionType?: keyof typeof NutritionType;
  pastSurgicalHistory?: string | null;
  systemicExamination?: string | null;
  cardiovascularSystem?: string | null;
  respiratorySystem?: string | null;
  centralNervousSystem?: string | null;
  abdomen?: string | null;
  genitalNRectum?: string | null;
  skin?: string | null;
  pulse?: string | null;
  extremities?: string | null;
  back?: string | null;
  uncommonSymptoms?: string | null;
  weightChanges?: string | null;
  fever?: string | null;
  ageOfLastChild?: string | null;
  obstetricPara?: string | null;
  obstetricGravida?: string | null;
  abortions?: string | null;
  sourceOfHistory?: string | null;
  chiefComplaints?: string | null;
  historyOfPresentIllness?: string | null;
  medicalHistory?: string | null;
  familyHistory?: string | null;
  admissiondiagnosis?: string | null;
  historyOfImmunization?: string | null;
  medicineReviewed?: boolean;
  assessmentType?: keyof typeof AssessmentType | null;
  code?: keyof typeof TriageCode | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  consciousness?: keyof typeof SedationScore | null;
  admission?: IAdmission | null;
  gynicHistory?: IGynicHistory | null;
  obstetricEvent?: IObstetricEvent | null;
}

export const defaultValue: Readonly<IPreAssessment> = {
  active: false,
  sexualAbuse: false,
  exposureToPets: false,
  medicineReviewed: false,
};
